import { render } from "./showWarehouseInvoice.vue?vue&type=template&id=6a36fa66&scoped=true"
import script from "./showWarehouseInvoice.vue?vue&type=script&lang=js"
export * from "./showWarehouseInvoice.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a36fa66"]])

export default __exports__